import { render } from "./AppLoadingIndicator.vue?vue&type=template&id=ada73360"
const script = {}
script.render = render

export default script